import { useEffect, useMemo, useState } from "react";
import type { ClearMode } from "../ConfirmTabChangeModal";
import { getId } from "./curriculumTabsABP.utils";
import type { TabIndex } from "./CurriculumTabsABPHeader";
import type { FormattedAsignatura } from "../../../interfaces/ObjetivosAprendizaje/iAsignaturas";
import type GetNiveles from "../../../data/GetNiveles";
import { useProyecto } from "../../../data/ProyectoContext";

type GetNivelesProps = React.ComponentProps<typeof GetNiveles>;

type Especialidad = { id: string; nombre: string };
type IdNombre = { id: string; nombre: string };

const EMPTY_ID_NOMBRE: IdNombre = { id: "", nombre: "" };

export interface UseCurriculumTabsABPLogicParams {

  allowedTP: boolean;

  nivelId: GetNivelesProps["selectedNivel"];
  handleNivelChangeABP: GetNivelesProps["onNivelChange"];

  selectedAsignatura: FormattedAsignatura | null;
  setSelectedAsignatura: React.Dispatch<
    React.SetStateAction<FormattedAsignatura | null>
  >;

  objetivosSeleccionados: any;
  setObjetivosSeleccionados: React.Dispatch<React.SetStateAction<any>>;
  setIsOAAdded: React.Dispatch<React.SetStateAction<boolean>>;


  nivelTPId: string;
  asignaturaTPId: string;
  clearTP: () => void;

  setPromptData: React.Dispatch<React.SetStateAction<any>>;
}

export interface UseCurriculumTabsABPLogicResult {

  tabValue: TabIndex;
  setTabValue: React.Dispatch<React.SetStateAction<TabIndex>>;

  confirmTabChangeOpen: boolean;
  clearMode: ClearMode;
  onConfirmTabChange: () => void;
  onCancelTabChange: () => void;


  onChangeTab: (_event: React.SyntheticEvent, newValue: TabIndex) => void;


  isTecnicoProfesional: boolean;
  isOrganizacion: boolean;


  especialidad: Especialidad | null;
  setEspecialidad: React.Dispatch<React.SetStateAction<Especialidad | null>>;
  especialidadId: string;


  nivelOrg: IdNombre;
  setNivelOrg: React.Dispatch<React.SetStateAction<IdNombre>>;
  asignaturaOrg: IdNombre;
  setAsignaturaOrg: React.Dispatch<React.SetStateAction<IdNombre>>;


  emptyIdNombre: IdNombre;
}

export function useCurriculumTabsABPLogic(
  params: UseCurriculumTabsABPLogicParams
): UseCurriculumTabsABPLogicResult {
  const {
    allowedTP,
    nivelId,
    handleNivelChangeABP,
    selectedAsignatura,
    setSelectedAsignatura,
    setObjetivosSeleccionados,
    setIsOAAdded,
    nivelTPId,
    asignaturaTPId,
    clearTP,
    setPromptData,
  } = params;

  const [tabValue, setTabValue] = useState<TabIndex>(0 as TabIndex);

  const [clearMode, setClearMode] = useState<ClearMode>("TP");
  const [clearFromTab, setClearFromTab] = useState<TabIndex | null>(null);
  const [pendingTab, setPendingTab] = useState<TabIndex | null>(null);
  const [confirmTabChangeOpen, setConfirmTabChangeOpen] = useState(false);

  const [especialidad, setEspecialidad] = useState<Especialidad | null>(null);
  const especialidadId = especialidad?.id ?? "";

  const [nivelOrg, setNivelOrg] = useState<IdNombre>(EMPTY_ID_NOMBRE);
  const [asignaturaOrg, setAsignaturaOrg] = useState<IdNombre>(EMPTY_ID_NOMBRE);

  const isTecnicoProfesional = tabValue === (2 as TabIndex);
  const isOrganizacion = tabValue === (1 as TabIndex);

    const { setProyecto } = useProyecto();

  const hasAnyTPSel = useMemo(
    () => Boolean(especialidadId || nivelTPId || asignaturaTPId),
    [especialidadId, nivelTPId, asignaturaTPId]
  );

  const nivelCNId = useMemo(() => getId(nivelId), [nivelId]);
  const materiaCNId = useMemo(
    () => (selectedAsignatura?.id ? String(selectedAsignatura.id) : ""),
    [selectedAsignatura]
  );
  const hasAnyCNSel = useMemo(
    () => Boolean(nivelCNId || materiaCNId),
    [nivelCNId, materiaCNId]
  );

  const hasAnyOrgSel = useMemo(
    () => Boolean(nivelOrg.id || asignaturaOrg.id),
    [nivelOrg.id, asignaturaOrg.id]
  );

  const hasAnyNonTPSel = useMemo(
    () => hasAnyCNSel || hasAnyOrgSel,
    [hasAnyCNSel, hasAnyOrgSel]
  );



  useEffect(() => {
    if (allowedTP) return;
    if (!isTecnicoProfesional) return;

    setEspecialidad(null);
    clearTP();
    setTabValue(0 as TabIndex);
  }, [allowedTP, isTecnicoProfesional, clearTP]);

  const clearNonTP_CN_ABP = () => {
    setSelectedAsignatura(null);
    setObjetivosSeleccionados((prev: any) => (Array.isArray(prev) ? [] : {}));
    setIsOAAdded(false);

    handleNivelChangeABP("", "" as any);

    setPromptData((prev: any) => ({
      ...prev,
      nivel_curso_cn: "",
      materias_cn: [],
    }));
    setProyecto((prev: any) => ({
    ...prev,
    nivel_curso_cn: "",
    materias_cn: [],
  }));

  console.log("SE LIMPIA CN");
  
  };

  useEffect(() => {
      console.log("Se activa limpieza:", clearFromTab);
      
    }, [clearFromTab]);

 const clearNonTP_ORG = () => {
  setNivelOrg(EMPTY_ID_NOMBRE);
 // setAsignaturaOrg(EMPTY_ID_NOMBRE);
  setPromptData((prev: any) => ({
    ...prev,
    nivel_curso_org: "",
    materias_org: [],
  }));
  setProyecto((prev: any) => ({
    ...prev,
    nivel_curso_org: "",
    materias_org: [],
  }));

  console.log("SE LIMPIA CN");
};

 

  const clearNonTP_All = () => {
    clearNonTP_CN_ABP();
    clearNonTP_ORG();
    console.log("Se limpian todos los estados");
    
  };


  const openConfirmForTabChange = (
    mode: ClearMode,
    fromTab: TabIndex,
    nextTab: TabIndex
  ) => {
    setClearMode(mode);
    setClearFromTab(fromTab);
    setPendingTab(nextTab);
    setConfirmTabChangeOpen(true);
  };

  const canNavigateToTP = (nextTab: TabIndex) => {
    if (nextTab !== (2 as TabIndex)) return true;
    return allowedTP;
  };

  const requiresConfirmLeavingTP = (nextTab: TabIndex) => {
    if (!isTecnicoProfesional) return false;
    if (nextTab === (2 as TabIndex)) return false;
    return hasAnyTPSel;
  };

  const requiresConfirmEnteringTPFromNonTP = (nextTab: TabIndex) => {
    // Solo aplica si estoy en CN u ORG y quiero ir a TP
    if (isTecnicoProfesional) return false;
    if (nextTab !== (2 as TabIndex)) return false;
    return hasAnyNonTPSel;
  };


  const onChangeTab = (_event: React.SyntheticEvent, newValue: TabIndex) => {
    const nextTab = newValue;

    if (!canNavigateToTP(nextTab)) return;

    if (requiresConfirmLeavingTP(nextTab)) {
      openConfirmForTabChange("TP", tabValue, nextTab);
      return;
    }

    if (requiresConfirmEnteringTPFromNonTP(nextTab)) {
      openConfirmForTabChange("NON_TP", tabValue, nextTab);
      return;
    }


    setTabValue(nextTab);

    if (isTecnicoProfesional && nextTab !== (2 as TabIndex)) {
      setEspecialidad(null);
      clearTP();
    }
  };

  const onConfirmTabChange = () => {
    if (clearMode === "TP") {
      setEspecialidad(null);
      clearTP();
    } 

    if (pendingTab !== null) setTabValue(pendingTab);

    setPendingTab(null);
    setClearFromTab(null);
    setConfirmTabChangeOpen(false);
  };

  const onCancelTabChange = () => {
    setPendingTab(null);
    setClearFromTab(null);
    setConfirmTabChangeOpen(false);
  };

  return {
    tabValue,
    setTabValue,

    confirmTabChangeOpen,
    clearMode,
    onConfirmTabChange,
    onCancelTabChange,

    onChangeTab,

    isTecnicoProfesional,
    isOrganizacion,

    especialidad,
    setEspecialidad,
    especialidadId,

    nivelOrg,
    setNivelOrg,
    asignaturaOrg,
    setAsignaturaOrg,

    emptyIdNombre: EMPTY_ID_NOMBRE,
  };
}
